import DataTableModule from '~/lib/vue/modules/datatable';
import rest from '~/lib/rest';
import constants from '~/lib/domain/constants';

/**
 * @param {~/lib.foundation.Container} services
 * @return {Object}
 */
export default (services, namespace='companies') => {

  return DataTableModule.create({
    namespace,
    services,
    url: '/customers',
    query: {
      filters: {
        match_type: constants.CUSTOMER_TYPE_COMPANY,
      },
    },
    columns: [
      {
        label: 'ID',
        value: row => row.id,
      },
      {
        label: 'Name',
        value: row => row.name,
      },
      {
        label: 'Email',
        value: row => row.email,
      },
      {
        label: 'Tel',
        value: row => row.tel,
      },
    ],
  });
};
